var Logger = (function() {

    var titleConfig = [
        'font-size: 16px;',
        'font-weight: 900;',
        'background: #FDFEFF;',
        'color: #051A38;'
    ];

    var stringConfig = [
        'font-size: 12px;',
        'background: #FDFEFF;',
        'color: #001820;'
    ];

    return {
        log : function(title, strings) {
            if (typeof strings === 'undefined') strings = [];
            if (localStorage.getItem('leadhit_secret')) {
                console.log('%c' + title, titleConfig.join(' '));
                strings.forEach(function(string) {
                    console.log('%c' + string, stringConfig.join(' '));
		        });
		        console.log('\r\n');
		    }
        }
    }
})();

export default Logger;
